import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <h4>No copyright issues | Feel free to copy</h4>
      <h4>By Tanmay with <span><i className="fa fa-heart" aria-hidden="true"></i></span></h4>
    </div>
  );
};

export default Footer;
